import { bookingStore } from 'entities/booking';
import { ClinicState } from 'entities/clinics/store/types';

export const clinicsMap = (clinics: ClinicState[]) => {
	return clinics.map(clinic => {
		return { id: clinic.id, name: clinic.name, info: clinic.info };
	});
};

export const bookingClinicsMap = () => {
	return bookingStore.clinics.map(clinic => {
		return { id: clinic.id, name: clinic.name };
	});
};
